import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'


const CheckboxItem = React.memo(({shouldChecked, ele, qua, onChange}) => {
	const label = ele.title === qua?.title
		? "Do not specify Course Unit"
		: `${ele.title} ${ele.code ? `(${ele.code})` : ""}`

	return (
		<FormControlLabel
			control={<Checkbox id={ele._id} value={ele._id} checked={shouldChecked} />}
			label={label}
			onChange={(e) => onChange(e)}
		/>
	)
})

export default CheckboxItem

